export default __webpack_public_path__ + "static/media/dilan.49b7fd5a.png";